<template>
  <div class="home">
    <img
      src="@/assets/images/0_img_banner.png"
      alt=""
      class="placeholder-banner"
    />
    <div class="container">
      <div class="title">Core Business</div>
      <div class="line-container">
        <div class="line short-line"></div>
        <div class="line middle-line"></div>
        <div class="line short-line" style="transform: scaleX(-1)"></div>
      </div>
      <div class="core-business flex mt100">
        <img src="@/assets/images/0_img_1.png" alt="" />
        <div class="right">
          <div class="title flex">
            <div class="triangle"></div>
            <span>Novel Drug Delivery Platform</span>
          </div>
          <div class="text">INNOVATIVE FORMULATION</div>
          <div class="list flex">
            <section>
              <div class="sec-title">Dosage Form</div>
              <div class="sec-text">
                Oral Films <br />
                Transdermal Patches Orally <br />
                Disintegrating Granule
              </div>
            </section>
            <section>
              <div class="sec-title">Application</div>
              <div class="sec-text">
                Children, the elderly, patients with special medical condition,
                pets
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="title flex title-2">
        <div class="triangle"></div>
<!--        <span>Novel Drug Delivery Platform</span>-->
        <span>One-Stop Industry Chain Service Platform</span>
      </div>
      <div class="flex step-list">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_2.png" alt="" />
          <div class="step-text">Product Strategy Design</div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_3.png" alt="" />
          <div class="step-text">
            Product Information Database & Project Launch Guidance
          </div>
        </div>
        <div class="li special-effects">
          <img src="@/assets/images/0_img_4.png" alt="" />
          <div class="step-text">Product Registration Services</div>
        </div>
      </div>
      <div class="flex step-list step-list-bot">
        <div class="li special-effects">
          <img src="@/assets/images/0_img_5.png" alt="" />
          <div class="step-text">Sales & Market Development</div>
        </div>
        <div class="li li-5 special-effects">
          <img src="@/assets/images/0_img_6.png" alt="" />
          <div class="step-text">
            Raw Material Supply & Product Distribution & Customized Services
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
};
</script>
<style lang="less" scoped>
.title {
  align-items: center;
  .triangle {
    width: 0;
    height: 0;
    border-top: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-left: 30px solid orange;
  }
  span {
    font-size: 26px;
    font-weight: bolder;
    margin-left: 20px;
  }
}
.core-business {
  .right {
    margin-left: 25px;
    .text {
      margin-top: 10px;
      font-size: 49px;
      color: #999;
      font-weight: 100;
      opacity: 0.2;
    }
    .list {
      justify-content: space-between;
      margin-top: 20px;
      section {
        width: 306px;
        height: 219px;
        background: #f9f9f9;
        padding: 38px 20px;
        box-sizing: border-box;
      }
      .sec-title {
        font-size: 24px;
        font-weight: bolder;
        color: #654495;
      }
      .sec-text {
        line-height: 35px;
        font-size: 16px;
        margin-top: 11px;
      }
    }
  }
}
.title-2 {
  margin-top: 60px;
}
.step-list {
  margin-top: 30px;
  flex-wrap: wrap;
  justify-content: space-between;
  .li {
    width: 400px;
    height: 322px;
    background: #f9f9f9;
  }
  .step-text {
    height: 70px;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
}
.step-list-bot{
  justify-content: center;
  .li-5{
    margin-left: 50px;
  }
}
</style>
